module.exports = __webpack_public_path__ + "img/f1-2-2.e4772c73.png";